import React, {useContext, useReducer, useRef} from 'react'
import {createPortal} from "react-dom";

export const reducer = (state, action) => {
  switch (action.type) {
    case 'setToast':
      return { ...state, ...action.payload };
  }
}

const ToastContext = React.createContext()

export const ToastProvider = ({ children}) => {
  const [state, dispatch] = useReducer(reducer, { show: false, message: null });
  const toastRef = useRef({});

  const toast = ({ title, message }) => {
    dispatch({ type: 'setToast', payload: { show: true, message, title }})
  }

  React.useEffect(() => {
    if (!toastRef.current) return

    if (state.show) {
      setTimeout(() => dispatch({ type: 'setToast', payload: { show: false }}), 2000)
    }
  }, [state.show])

  return <ToastContext.Provider value={{ toast }}>
    {children}
    {createPortal(
      <div
        className={`z-50 w-full absolute transition-all duration-700 bg-[#4F98BD] ease-in-out text-slate-200 py-1 text-lg text-center ${state.show ? 'top-0' : '-top-20'}`}
        ref={toastRef}>
        <div>{state.message}</div>
      </div>,
      document.body,
    )}
    </ToastContext.Provider>
}

export const useToast = () => useContext(ToastContext)